// extracted by mini-css-extract-plugin
module.exports = {"w1g611fv":"w1g611fv"};